import React, { useState } from 'react';
import useTranslate from '../../../customHooks/useTranslate';
import SectionTitle from '../yourProperties/Title';
import IconButton from '../../../muiComponents/IconButton';
import Title from '../../components/Title';
import { BookingRoomState } from '../../../types/booking/BookingTypes';
import RoomInfo from './RoomInfo';

interface RoomsListProps {
    rooms: BookingRoomState[];
    nights: number;
    checkIn: Date | null;
    currencyKey: string;
}

const RoomsList = (props: RoomsListProps) => {
    const { rooms, nights, checkIn, currencyKey } = props;

    const [isVisibleSection, setIsVisibleSection] = useState(true);
    const translate = useTranslate();

    const supportText = `${rooms.length} ${translate(
        rooms.length === 1 ? 'room' : 'rooms'
    )}  · ${nights} ${translate(nights === 1 ? 'night' : 'nights')}`;

    return (
        <section className='booking__section'>
            <div
                className={`flex flex-between flex-align-baseline ${
                    !isVisibleSection ? 'border-color-bottom' : ''
                }`}
            >
                <SectionTitle text={translate('rooms')} />
                <div className=' flex gap-20'>
                    {isVisibleSection ? (
                        <Title className='text-capitalize booking__small-label'>
                            {supportText}
                        </Title>
                    ) : (
                        ''
                    )}
                    <IconButton
                        iconName={
                            isVisibleSection ? 'ExpandLess' : 'ExpandMore'
                        }
                        onClick={() => setIsVisibleSection(!isVisibleSection)}
                    />
                </div>
            </div>
            {isVisibleSection
                ? rooms.map(room => (
                      <RoomInfo
                          key={room.id}
                          room={room}
                          checkIn={checkIn}
                          currencyKey={currencyKey}
                      />
                  ))
                : ''}
        </section>
    );
};

export default RoomsList;
